import React from "react";
import { motion } from "framer-motion";
import { profiles } from "./constants";
import "../styles/Profiles.css";

function Profiles() {
  return (
    <motion.div
      className="profiles page"
      variants={{
        hidden: { opacity: 0, y: 75 },
        visible: { opacity: 1, y: 0 },
      }}
      initial="hidden"
      animate="visible"
      transition={{ duration: 0.5, delay: 0.25 }}
    >
      <h1 className="page-heading">Profiles</h1>
      <p className="page-subtitle">
        1000+ DSA problems solved across platforms. Competitive programming, open source, and writing.
      </p>

      <div className="profiles__grid">
        {profiles.map((profile) => (
          <a
            className="profile__card"
            href={profile.link}
            rel="noreferrer"
            target="_blank"
            key={profile.platform}
          >
            <h2>{profile.platform}</h2>
            <p className="profile__handle">@{profile.handle}</p>
            <p className="profile__stat">{profile.stat}</p>
          </a>
        ))}
      </div>
    </motion.div>
  );
}

export default Profiles;
